const PhoneBuyBackSectionHeader = ({ title, children }) => (
  <>
    <div className="text-[24px] text-center font-semibold md:text-[32px]">
      {title}
    </div>

    <div className="text-[14px] text-center max-w-[80%] m-auto">{children}</div>
  </>
);

export default PhoneBuyBackSectionHeader;
